module.exports = __webpack_public_path__ + "img/ktb.3402938c.svg";